var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "outageClockContainer" } },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": false },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      !_vm.data.selected.unit
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger text-center",
              attrs: { role: "alert" },
            },
            [
              _c("h2", { staticClass: "text-danger" }, [
                _vm._v(" " + _vm._s(_vm.$t("pleaseSelectUnit")) + " "),
              ]),
            ]
          )
        : _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-10 offset-1 text-center" }, [
              !_vm.isEmbedded
                ? _c("h2", { staticClass: "text-center my-2 page-title" }, [
                    _vm._v(" " + _vm._s(_vm.$t("outageBestPractice")) + " "),
                  ])
                : _vm._e(),
              _c("div", { attrs: { id: "chart-container" } }),
            ]),
            !_vm.isEmbedded
              ? _c(
                  "div",
                  { staticClass: "col-1 outage-clock-stats-container" },
                  [
                    _c("div", { staticClass: "row border-bottom" }, [
                      _c("div", { staticClass: "col-12 my-2 bold" }, [
                        _vm._v(" Outages progress "),
                      ]),
                      _c("div", { staticClass: "col-12 my-1" }, [
                        _c("span", { staticClass: "red-color" }),
                        _c("span", { staticClass: "ml-2" }, [_vm._v("< 50%")]),
                        _c("span", { staticClass: "float-right bold" }, [
                          _vm._v(_vm._s(_vm.getOutagesNumberByScore(0, 49.99))),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-12 my-1" }, [
                        _c("span", { staticClass: "green-color" }),
                        _c("span", { staticClass: "ml-2" }, [_vm._v(">= 50%")]),
                        _c("span", { staticClass: "float-right bold" }, [
                          _vm._v(_vm._s(_vm.getOutagesNumberByScore(50, 100))),
                        ]),
                      ]),
                    ]),
                    _vm._m(0),
                    _c("div", { staticClass: "row my-3" }, [
                      _vm._m(1),
                      _c("div", { staticClass: "col-3 bold" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getOutagesInInitiationPhase()) + " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row my-3" }, [
                      _vm._m(2),
                      _c("div", { staticClass: "col-3 bold" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getOutagesInScopingPhase()) + " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row my-3" }, [
                      _vm._m(3),
                      _c("div", { staticClass: "col-3 bold" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getOutagesInPreparationPhase()) + " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row my-3" }, [
                      _vm._m(4),
                      _c("div", { staticClass: "col-3 bold" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getOutagesInImplementationPhase()) +
                            " "
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "row my-3" }, [
                      _vm._m(5),
                      _c("div", { staticClass: "col-3 bold" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getOutagesInCloseOutPhase()) + " "
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
      _vm.filterEnabled
        ? [
            _c(
              "div",
              {
                staticClass: "filter-show",
                class: { "visible-button": _vm.filterVisible },
                on: {
                  click: function ($event) {
                    _vm.filterVisible = !_vm.filterVisible
                  },
                },
              },
              [
                _c("div", { staticClass: "content" }, [
                  _c(
                    "span",
                    [
                      _vm._v(" " + _vm._s(_vm.$t("filter")) + " "),
                      _c("font-awesome-icon", {
                        attrs: { icon: "angle-down" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "filter-container pt-3 pb-2 pl-2 pr-2",
                class: [{ visible: _vm.filterVisible }],
              },
              [
                _c("h6", [
                  _vm._v(
                    _vm._s(_vm.$t("plant")) + " / " + _vm._s(_vm.$t("unit"))
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "filter-hide text-center filter-button",
                    on: {
                      click: function ($event) {
                        _vm.filterVisible = !_vm.filterVisible
                      },
                    },
                  },
                  [_vm._v(" × ")]
                ),
                _c(
                  "ul",
                  { staticClass: "filter pl-2 pr-2" },
                  [
                    _c("li", [
                      _c(
                        "div",
                        {
                          staticClass: "form-check area-item",
                          staticStyle: { "background-color": "#f3f5f7" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.allSelected,
                                expression: "allSelected",
                              },
                            ],
                            attrs: { type: "checkbox", id: "selectAll" },
                            domProps: {
                              checked: Array.isArray(_vm.allSelected)
                                ? _vm._i(_vm.allSelected, null) > -1
                                : _vm.allSelected,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.allSelected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.allSelected = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.allSelected = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.allSelected = $$c
                                  }
                                },
                                function ($event) {
                                  return _vm.onSelectAllChange(_vm.allSelected)
                                },
                              ],
                            },
                          }),
                          _c("label", { attrs: { for: "selectAll" } }, [
                            _vm._v(" " + _vm._s(_vm.$t("selectAll")) + " "),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._l(_vm.filter, function (plant, plantIndex) {
                      return _c(
                        "li",
                        { key: plantIndex, staticClass: "filter-header" },
                        [
                          _c("div", { class: ["form-check", "area-item"] }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: plant.selected,
                                  expression: "plant.selected",
                                },
                              ],
                              attrs: {
                                id: "plantFilter-" + plantIndex,
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(plant.selected)
                                  ? _vm._i(plant.selected, null) > -1
                                  : plant.selected,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = plant.selected,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            plant,
                                            "selected",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            plant,
                                            "selected",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(plant, "selected", $$c)
                                    }
                                  },
                                  function ($event) {
                                    return _vm.onPlantFilterChange(
                                      $event,
                                      plant
                                    )
                                  },
                                ],
                              },
                            }),
                            _c(
                              "label",
                              { attrs: { for: "plantFilter-" + plantIndex } },
                              [_vm._v(" " + _vm._s(plant.name) + " ")]
                            ),
                          ]),
                          plant.units !== undefined && plant.units.length > 0
                            ? _c(
                                "ul",
                                { staticClass: "sub-filter" },
                                _vm._l(plant.units, function (item, itemIndex) {
                                  return _c(
                                    "li",
                                    {
                                      key: itemIndex,
                                      class: [
                                        "filter-item",
                                        _vm.getRowClass(itemIndex),
                                      ],
                                    },
                                    [
                                      _c("div", { staticClass: "form-check" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: item.selected,
                                              expression: "item.selected",
                                            },
                                          ],
                                          attrs: {
                                            id:
                                              "plantFilter-" +
                                              plantIndex +
                                              "-item-" +
                                              itemIndex,
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              item.selected
                                            )
                                              ? _vm._i(item.selected, null) > -1
                                              : item.selected,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a = item.selected,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        item,
                                                        "selected",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        item,
                                                        "selected",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    item,
                                                    "selected",
                                                    $$c
                                                  )
                                                }
                                              },
                                              function ($event) {
                                                return _vm.onUnitFilterChange(
                                                  $event,
                                                  plant,
                                                  item
                                                )
                                              },
                                            ],
                                          },
                                        }),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for:
                                                "plantFilter-" +
                                                plantIndex +
                                                "-item-" +
                                                itemIndex,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.name) + " "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                    _c("li", [
                      _c("label", { staticClass: "mt-3 mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("duration") + " (" + _vm.$t("days") + ")"
                          )
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "input-group input-group-sm mb-2 mt-1" },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(_vm._s(_vm.$t("min"))),
                            ]),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.minDuration,
                                expression: "minDuration",
                              },
                            ],
                            staticClass: "form-control filter-input",
                            attrs: { type: "number", min: "0" },
                            domProps: { value: _vm.minDuration },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.minDuration = $event.target.value
                              },
                            },
                          }),
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(_vm._s(_vm.$t("max"))),
                            ]),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.maxDuration,
                                expression: "maxDuration",
                              },
                            ],
                            staticClass: "form-control filter-input",
                            attrs: { type: "number", min: "0" },
                            domProps: { value: _vm.maxDuration },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.maxDuration = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                    _c("li", [
                      _c("label", { staticClass: "mt-3 mb-0" }, [
                        _vm._v(_vm._s(_vm.$t("score") + " (%)")),
                      ]),
                      _c(
                        "div",
                        { staticClass: "input-group input-group-sm mb-2 mt-1" },
                        [
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(_vm._s(_vm.$t("min"))),
                            ]),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.minScore,
                                expression: "minScore",
                              },
                            ],
                            staticClass: "form-control filter-input",
                            attrs: { type: "number", min: "0", max: "100" },
                            domProps: { value: _vm.minScore },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.minScore = $event.target.value
                              },
                            },
                          }),
                          _c("div", { staticClass: "input-group-prepend" }, [
                            _c("span", { staticClass: "input-group-text" }, [
                              _vm._v(_vm._s(_vm.$t("max"))),
                            ]),
                          ]),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.maxScore,
                                expression: "maxScore",
                              },
                            ],
                            staticClass: "form-control filter-input",
                            attrs: { type: "number", min: "0", max: "100" },
                            domProps: { value: _vm.maxScore },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.maxScore = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm mt-1",
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("refresh")) + " ")]
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 mt-3 bold" }, [
        _vm._v(" Phases / Outages nr. "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _vm._v(" Initiation"),
      _c("small", { staticClass: "bold", staticStyle: { display: "block" } }, [
        _vm._v("545 days"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _vm._v(" Scoping"),
      _c("small", { staticClass: "bold", staticStyle: { display: "block" } }, [
        _vm._v("365 days"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _vm._v(" Preparation"),
      _c("small", { staticClass: "bold", staticStyle: { display: "block" } }, [
        _vm._v("185 days"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _vm._v(" Implementation"),
      _c("small", { staticClass: "bold", staticStyle: { display: "block" } }, [
        _vm._v("60 days"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-9" }, [
      _vm._v(" Close Out"),
      _c("small", { staticClass: "bold", staticStyle: { display: "block" } }, [
        _vm._v("90 days"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }